import { SHOP_ID } from '@/utils/const'
import flat from './flat'
import { homePageUrl, cartUrl } from './const'

export const TYPE_POSTAGE = 'postage' //凑邮专区 凑单接接口
export const TYPE_NEW = 'new' // 上新专区 分页类全部 新品 20
export const TYPE_HOT = 'hot' //热卖专区 分类页 全部 综合 20

export function getAddOnData(shopId = SHOP_ID) {
  return flat(`${cartUrl}/get_add_on_items?shopId=${shopId}`)
}

/**
 * 获取分类页数据
 * @param {object} opt
 * @param {number} opt.sortType 0 :根据转化率降序 2 :根据销量降序 4 :根据创建时间倒序 5 :根据价格升序 6 :根据价格降序
 * @param {number} [opt.categoryId]
 * @param {number} [opt.shopId]
 * @param {number} opt.pageIndex
 * @param {number} opt.pageSize
 *
 * @returns
 */
export function fetchClassifyData(opt) {
  return flat(`${homePageUrl}/search_goods_by_categoryId`, {
    method: 'POST',
    body: {
      ...opt,
      shopId: SHOP_ID,
    },
  })
}

export function fetchTagsData(tagId, shopId = SHOP_ID) {
  // return flat(`${cartUrl}/get_add_on_items?shopId=${shopId}`)

  return flat(`${homePageUrl}/search_goods_by_tagId?tagId=${tagId}&shopId=${shopId}`)
}

/**
 *
 * @param {string} type
 * @param {number} [shopId]
 * @returns
 */
export function getPrefectureData(type, shopId = SHOP_ID) {
  if (type === TYPE_POSTAGE) {
    return flat(`${cartUrl}/get_add_on_items?shopId=${shopId}`)
  }
  if (type === TYPE_NEW) {
    return flat(`${homePageUrl}/search_goods_by_categoryId`, {
      method: 'POST',
      body: {
        sortType: 4,
        pageIndex: 1,
        pageSize: 20,
        shopId: SHOP_ID,
      },
    })
  }
  if (type === TYPE_HOT) {
    return flat(`${homePageUrl}/search_goods_by_categoryId`, {
      method: 'POST',
      body: {
        sortType: 0,
        pageIndex: 1,
        pageSize: 20,
        shopId: SHOP_ID,
      },
    })
  }
  return flat(`${cartUrl}/get_add_on_items?shopId=${shopId}`)
  // const _d = TYPE_MAP[type] || TYPE_MAP['postage']
}
